module.exports = __webpack_public_path__ + "img/kia-hero-mobile.9cbfdd14.png";